import { render } from "./CommandsPage.vue?vue&type=template&id=775a1c81&scoped=true"
import script from "./CommandsPage.vue?vue&type=script&lang=js"
export * from "./CommandsPage.vue?vue&type=script&lang=js"

import "./CommandsPage.vue?vue&type=style&index=0&id=775a1c81&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775a1c81"]])

export default __exports__